import {Dispatch} from 'react'
import {generalOpenModalError, generalOpenModalMessage, generalShowLoader} from '../general.actions'
import {KEYS} from '../../constants/keysStorage'
import * as http from '../../api/http'
import {ENDPOINTS} from '../../api/config'
import { LIBROS_TYPES } from '../../constants/libros.types'
import { State } from '../../reducers'
import { LibroComprasEditar } from '../../interfaces/libros/compras.interface'
import { descargarBase64, descargarCsvArchivos } from '../../utils/file'

const COMPRAS_FILE = process.env.REACT_APP_COMPRAS_FILE;

export const setFormCompras = (form: any) => ({ type: LIBROS_TYPES.COMPRAS_CHANGE_FORM_CARGA, payload: form })
export const setDataLibrosCompras = (data: any) => ({ type: LIBROS_TYPES.COMPRAS_SET_DATA_LIBROS, payload: data })
export const setLibroActivoCompras = (data: any) => ({ type: LIBROS_TYPES.COMPRAS_SET_LIBRO_ACTIVO, payload: data })
export const setDataFileCompras = (dataFile: any) => ({ type: LIBROS_TYPES.COMPRAS_SET_FILE_DATA_CARGADA, payload: dataFile })
export const setResultJsonHacienda = (jsonResponse: Array<any>) => ({ type: LIBROS_TYPES.JSON_RESPONSE_HACIENDA_DTE, payload: jsonResponse })
export const clearLibroComprasModule = () => ({ type: LIBROS_TYPES.LIBROS_CLEAR_MODULE, payload: {} })

export const getLibrosCompras = () => async (dispatch: Dispatch<any>) => {
  dispatch(generalShowLoader(true));
  const formConsulta = {
    tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
  }

  await http
    .post(ENDPOINTS.LIBRO_COMPRAS_GET_GENERADOS, formConsulta, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      const dataLibros = res?.body?.length > 0 ? res.body : [];
      dispatch(setDataLibrosCompras(dataLibros));
    })
    .catch((err) => {
      const messageErr = 'No se logró obtener los datos de los libros';
      dispatch(generalOpenModalError(err?.response?.data?.message ?? messageErr, err?.response?.data?.status))
    })
    .finally(() => dispatch(generalShowLoader(false)))
}

export const postCargarLibrosCompras = (form: any, base64Str: string) => async (dispatch: Dispatch<any>) => {
  dispatch(generalShowLoader(true));
  const formConsulta = {
    base64File: base64Str,
    typeFile: form.ext,
    fechaDeclaracion: form.declaracion,
    descripcion: form.descripcion,
    varianteCargaCompras: form.varianteCargaCompras,
    itemsFile: form.datosHacienda ?? [],
    tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
  }

  return await http
    .post(ENDPOINTS.LIBRO_COMPRAS_CARGAR_NUEVO, formConsulta, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      dispatch(generalOpenModalMessage("Libro cargado exitosamente", "Los registros del libro ya fueron ingresados al sistema."));
      dispatch(getLibrosCompras());
      return true;
    })
    .catch((err) => {
      const messageErr = 'No se logró cargar el libro, intente nuevamente.';
      dispatch(generalOpenModalError(err?.response?.data?.message ?? messageErr, err?.response?.data?.status))
      return false;
    })
    .finally(() => dispatch(generalShowLoader(false)))
}

export const getLibroComprasDetallado = (idLibro: number, exportar:boolean = false, libroActivo: any) => async (dispatch: Dispatch<any>) => {
  dispatch(generalShowLoader(true));
  const formConsulta = {
    idLibro,
    exportar,
    incluirCsv: exportar,
    tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
  }

  return await http
    .post(ENDPOINTS.LIBRO_COMPRAS_GET_DETALLADO, formConsulta, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      dispatch(setLibroActivoCompras({libroActivo, detalle: res?.body}));

      if (exportar) {
        const itemExcel = res?.body[0];
        descargarBase64(itemExcel?.Excel, 'application/vnd.ms-excel', `${COMPRAS_FILE}`);
        descargarCsvArchivos(itemExcel?.CsvArchivos);
      }
      return true;
    })
    .catch((err) => {
      const messageErr = 'No se logró exportar el libro, intente nuevamente.';
      dispatch(generalOpenModalError(err?.response?.data?.message ?? messageErr, err?.response?.data?.status))
      return false;
    })
    .finally(() => dispatch(generalShowLoader(false)))
}

// Guarda la clasificacion (columnas Q, R, S, T del anexo 3) de las compras que se cambiaron en "Ver libro".
// items: una fila por compra con sus 4 datos; el servidor guarda todo o nada. Despues se vuelve a leer el detalle del libro.
export const editClasificacionCompras = (libroActivo: any, items: Array<{ numcorrelativo: number; tipooperacion: number; clasificacion: number; sector: number; tipoclasificacion: number }>) => async (dispatch: Dispatch<any>) => {
  dispatch(generalShowLoader(true));

  const formEdit = {
    idlibrocompras: libroActivo.idlibrocompras,
    items,
  }

  return await http
    .put(ENDPOINTS.LIBRO_COMPRAS_EDIT_CLASIFICACION, formEdit, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      await dispatch(getLibroComprasDetallado(libroActivo.idlibrocompras, false, libroActivo));
      dispatch(generalOpenModalMessage("Clasificación guardada", res?.message ?? "La clasificación de las compras fue guardada."));
      return true;
    })
    .catch((err) => {
      const messageErr = 'No se logró guardar la clasificación de las compras, intente nuevamente.';
      dispatch(generalOpenModalError(err?.response?.data?.message ?? messageErr, err?.response?.data?.status))
      dispatch(generalShowLoader(false));
      return false;
    });
}

// Facturas de sujeto excluido (ANEXO 5) del periodo declarado del libro, con su clasificacion. Devuelve null si falla la consulta.
export const getComprasSujetosExcluidos = (idlibrocompras: number) => async (dispatch: Dispatch<any>) => {
  return await http
    .post(ENDPOINTS.LIBRO_COMPRAS_GET_SUJETOS_EXCLUIDOS, { idlibrocompras }, {}, KEYS.TOKEN)
    .then((res: any) => (Array.isArray(res?.data) ? res.data : []))
    .catch(() => null)
}

// Guarda la clasificacion de las facturas de sujeto excluido que se cambiaron en "Ver libro" (todo o nada en el servidor).
export const editClasificacionSujetosExcluidos = (libroActivo: any, items: Array<{ numerodocumento: string; tipooperacion: number; clasificacion: number; sector: number; tipoclasificacion: number }>) => async (dispatch: Dispatch<any>) => {
  dispatch(generalShowLoader(true));

  return await http
    .put(ENDPOINTS.LIBRO_COMPRAS_EDIT_CLASIFICACION_SUJETOS_EXCLUIDOS, { idlibrocompras: libroActivo.idlibrocompras, items }, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      dispatch(generalShowLoader(false));
      dispatch(generalOpenModalMessage("Clasificación guardada", res?.message ?? "La clasificación de las compras a sujetos excluidos fue guardada."));
      return true;
    })
    .catch((err) => {
      const messageErr = 'No se logró guardar la clasificación de las compras a sujetos excluidos, intente nuevamente.';
      dispatch(generalOpenModalError(err?.response?.data?.message ?? messageErr, err?.response?.data?.status))
      dispatch(generalShowLoader(false));
      return false;
    });
}

export const getJsonDteHacienda = (listadosDte: Array<any>) => async (dispatch: Dispatch<any>) => {
  dispatch(generalShowLoader(true));

  const formConsulta = {
    listadoBusquedaDte: listadosDte,
    tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
  }

  return await http
    .post(ENDPOINTS.LIBRO_CONSULTA_JSON_DTE, formConsulta, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      if (res.body?.length > 0) {
        dispatch(setResultJsonHacienda(res.body));
      }
      return true;
    })
    .catch((err) => {
      const messageErr = 'No se logró consultar los documentos con Hacienda, intente nuevamente.';
      dispatch(generalOpenModalError(err?.response?.data?.message ?? messageErr, err?.response?.data?.status))
      return false;
    })
    .finally(() => dispatch(generalShowLoader(false)))
}

export const deleteLibroCompras = (idlibrocompras: number) => async (dispatch: Dispatch<any>) => {
  dispatch(generalShowLoader(true));

  const formDelete = {
    idlibrocompras
  }

  return await http
    ._delete(ENDPOINTS.LIBRO_COMPRAS_DELETE, formDelete, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      dispatch(generalOpenModalMessage("Libro eliminado", "El libro de compras y sus registros han sido eliminados exitosamente."));
      dispatch(getLibrosCompras());
      return true;
    })
    .catch((err) => {
      const messageErr = 'No se logró eliminar el libro, intente nuevamente.';
      dispatch(generalOpenModalError(err?.response?.data?.message ?? messageErr, err?.response?.data?.status))
      dispatch(generalShowLoader(false));
      return false;
    });
}

export const deleteLibroComprasDetalle = (detalleLibro: any, libroActivo: any) => async (dispatch: Dispatch<any>, getState: () => State) => {
  dispatch(generalShowLoader(true));
  
  const { detalle } = getState().libros.comprasLibroActivo;
  const formDelete = {
    idlibrocompras: libroActivo?.idlibrocompras,
    numcorrelativo: detalleLibro?.numcorrelativo,
    numcomprobante: detalleLibro?.numcomprobante,
  }

  return await http
    ._delete(ENDPOINTS.LIBRO_COMPRAS_DELETE, formDelete, {}, KEYS.TOKEN)
    .then(async (res: any) => {

      if (detalle?.length > 0) {
        const filterDetalles = detalle?.filter((registro:any) => 
          registro.numcorrelativo !== detalleLibro?.numcorrelativo
        );
        dispatch(setLibroActivoCompras({libroActivo, detalle: filterDetalles}));
        dispatch(generalShowLoader(false));
      } else {
        dispatch(getLibroComprasDetallado(formDelete.idlibrocompras, false, libroActivo));
      }
      
      dispatch(generalOpenModalMessage("Registro eliminado", "El registro del libro de compras ha sido eliminado exitosamente."));
      return true;
    })
    .catch((err) => {
      const messageErr = 'No se logró eliminar el registro del libro, intente nuevamente.';
      dispatch(generalOpenModalError(err?.response?.data?.message ?? messageErr, err?.response?.data?.status))
      dispatch(generalShowLoader(false));
      return false;
    });
}

export const editLibroCompras = (libroEditado: LibroComprasEditar) => async (dispatch: Dispatch<any>) => {
  dispatch(generalShowLoader(true));

  const formEdit = {
    ...libroEditado,
    descripcion: libroEditado.descripcion.trim(),
  }

  return await http
    .put(ENDPOINTS.LIBRO_COMPRAS_EDIT, formEdit, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      dispatch(generalOpenModalMessage("Libro editado", "El libro de compras ha sido modificado exitosamente."));
      dispatch(getLibrosCompras());
      return true;
    })
    .catch((err) => {
      const messageErr = 'No se logró editar el libro, intente nuevamente.';
      dispatch(generalOpenModalError(err?.response?.data?.message ?? messageErr, err?.response?.data?.status))
      dispatch(generalShowLoader(false));
      return false;
    });
}